// extracted by mini-css-extract-plugin
export default {"overviewSummary":"StackedSummaryTable--overviewSummary--OzdEe"};